import React, { useContext } from 'react';
import { Box, Button, MenuItem, TextField, Grid } from '@mui/material';
import '../../assets/styles/FilterBar.scss';
import { ChannelContext } from '../../context';
import CommonDateRangePicker from '../common/CommonDateRangePicker';

export default function FilterBar() {
    const { filters, setFilters, initialFilters, onLoadApi } = useContext(ChannelContext);

    const handleChange = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
    };

    const handleDateRangeChange = ({ startDate, endDate }) => {
        setFilters(prev => ({
            ...prev,
            dateRange: { startDate, endDate }
        }));
    };

    const handleSearch = () => {
        onLoadApi(filters);
    };

    const handleReset = () => {
        setFilters(initialFilters);
        onLoadApi(initialFilters);
    };

    return (
        <Box className="shipment-filter-bar">
            <Grid container spacing={2}>
                <Grid item size={{ xs: 12, md: 4 }}>
                    <div className="search-box">
                        <TextField
                            select
                            name="searchBy"
                            value={filters.searchBy}
                            onChange={(e) => handleChange('searchBy', e.target.value)}
                            size="small"
                            className="search-select"
                            SelectProps={{
                                displayEmpty: true,
                            }}
                        >
                            <MenuItem value="channel_name">CHANNEL</MenuItem>
                            <MenuItem value="store_name">STORE NAME</MenuItem>
                        </TextField>

                        <TextField
                            size="small"
                            placeholder="Search..."
                            value={filters.searchValue}
                            onChange={(e) => handleChange('searchValue', e.target.value)}
                            className="search-input"
                        />
                    </div>
                </Grid>

                <Grid item size={{ xs: 12, md: 4 }}>
                    <Box className="date-picker-wrapper">
                        <CommonDateRangePicker
                            startDate={filters?.dateRange?.startDate}
                            endDate={filters?.dateRange?.endDate}
                            onChange={handleDateRangeChange}
                        />
                    </Box>
                </Grid>

                <Grid item size={{ xs: 12, md: 4 }}>
                    <Box className="filter-actions" sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                        <Button className="search-btn" variant="contained" size="medium" onClick={handleSearch}>
                            Search
                        </Button>
                        <Button className="reset-btn" variant="outlined" size="medium" onClick={handleReset}>
                            Reset
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
